import React, { Component } from 'react';
import Table from './Table/Table';
import MoreModal from '../../shared/Modal/MoreModal'
import {Link} from 'react-router-dom'
class WidrovalComponent extends Component {
    state = {
        search: "",
        moreModal: false,
        key: null
    }
    componentWillMount() {
        this.props.getPayments({
            type: "withdrawal"
        })
    }
    onSearchChange = (value) => {
        this.setState({ search: value })
    }
    onFilter = () => {
        this.props.resetReducer("RESET_PAYMENTS_REDUCER")
        let body = {
            type: "withdrawal",
            search: {type: "email", value: this.state.search}
        }
        this.props.getPayments(body)
    }
    onMoreModal = (key) => {
        this.setState({
            moreModal: true,
            key: key
        })
    }
    onModalClose = () => {
        this.setState({
            moreModal: false,
            key: null
        })
    }
    render() {
        return (
            <React.Fragment>
                 <div className="content-header clearfix" style={{ borderBottom: "1px solid lightgray", marginBottom: "20px" }}>
                    <h1>WITHDRAWALS</h1>
                    <Link to="/admin/withdrawals-settings" className="btn btn-success">Withdrawals Settings</Link>
                </div>
                <div className="shadow-widget">
                    <div className="row pt-3">
                        <div className="col-md-2">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={this.state.search}
                                    onChange={(e) => this.onSearchChange(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-1">
                            <div className="form-group">
                                <button className="btn btn-success" onClick={() => this.onFilter()}>Filter</button>
                            </div>
                        </div>
                    </div>
                </div>
                <Table
                    paymentsReducer={this.props.paymentsReducer}
                    getPaymentsLast={this.props.getPaymentsLast}
                    DashboardReducer={this.props.DashboardReducer}
                    search={this.state.search}
                    onMoreModal={this.onMoreModal}
                    getPaymentsApprove={this.props.getPaymentsApprove}
                />
                {this.state.moreModal && <MoreModal
                    type="Payment"
                    data={this.props.paymentsReducer.paymentsData[this.state.key]}
                    onModalClose={this.onModalClose}
                />}
            </React.Fragment>
        );
    }
}

export default WidrovalComponent;
